import { MarketExpansionFilterData } from "@app/overviews/market-expansion-dashboard/shared/MarketExpansionFilterData";
import { MarketExpansionLineOfBusinessEnum } from "@app/overviews/market-expansion-dashboard/shared/MarketExpansionLineOfBusinessEnum";
import { MedicareCountyEnrollment } from "@app/overviews/market-expansion-dashboard/shared/MedicareCountyEnrollment";
import { MarketplaceCountyPlanCounts, MarketplacePayerPlanCount } from "@app/overviews/market-expansion-dashboard/shared/MarketplaceCountyPlanCounts";
import { MarketplaceMarketShareFilterCriteria } from "@app/overviews/market-expansion-dashboard/shared/MarketplaceMarketShareFilterCriteria";
import { MedicaidCountyPrograms, MedicaidPayerPlanCount } from "@app/overviews/market-expansion-dashboard/shared/MedicaidCountyPrograms";
import { MedicaidMarketOpportunityFilterCriteria } from "@app/overviews/market-expansion-dashboard/shared/MedicaidMarketOpportunityFilterCriteria";
import { MedicaidMarketShareFilterCriteria } from "@app/overviews/market-expansion-dashboard/shared/MedicaidMarketShareFilterCriteria";
import { MedicaidProgram } from "@app/overviews/market-expansion-dashboard/shared/MedicaidProgram";
import { ProviderFootprintFilterCriteria } from "@app/overviews/market-expansion-dashboard/shared/ProviderFootprintFilterCriteria";
import { ProviderFootprintRecord } from "@app/overviews/market-expansion-dashboard/shared/ProviderFootprintRecord";
import ServiceBase from "@app/shared/serviceBase";
import { ProviderLandscapeFilterCriteria } from "@app/overviews/market-expansion-dashboard/shared/ProviderLandscapeFilterCriteria";
import { ProviderLandscapeCountyCaseCount } from "@app/overviews/market-expansion-dashboard/shared/ProviderLandscapeCountyCaseCounts";

export default class MarketExpansionService extends ServiceBase {
  private marketExpansionEndpoint = `${this.apiEndpoint}/marketexpansion`;

  public async getMarketExpansionLinesOfBusiness(clientId: number): Promise<MarketExpansionLineOfBusinessEnum[]> {
    return await this.makeGet<MarketExpansionLineOfBusinessEnum[]>(`${clientId}/lines-of-business`, null, this.marketExpansionEndpoint);
  }

  public async getMarketExpansionStateCountyFilters(clientId: number, lineOfBusinessId: number): Promise<MarketExpansionFilterData> {
    return await this.makeGet<MarketExpansionFilterData>(`${clientId}/line-of-business/${lineOfBusinessId}/state-county-filters`, null, this.marketExpansionEndpoint);
  }

  public async cacheAllMedicareMarketOpportunityHistoricalData(): Promise<boolean> {
    return await this.makePost(`cache-all-medicare-market-opportunity-records`, null, this.marketExpansionEndpoint);
  }

  public async searchMedicareCountyEnrollments(countySSAs: string[]): Promise<MedicareCountyEnrollment[]> {
    return await this.makePost(`search-medicare-market-opportunity-county-enrollments`, countySSAs, this.marketExpansionEndpoint);
  }

  public async searchMarketplaceCountyPlanCounts(stateCode: string): Promise<MarketplaceCountyPlanCounts[]> {
    return await this.makePost(`search-marketplace-market-opportunity-county-plan-counts`, stateCode, this.marketExpansionEndpoint);
  }

  public async searchMarketplacePayerDistinctPlanCounts(filterCriteria: MarketplaceMarketShareFilterCriteria, signal?: AbortSignal): Promise<MarketplacePayerPlanCount[]> {
    return await this.makePost(`search-marketplace-market-opportunity-payers-market-share`, filterCriteria, this.marketExpansionEndpoint, false, "application/json", true, undefined, signal);
  }

  public async getMedicaidMarketOpportunityPrograms(stateCode: string, signal?: AbortSignal): Promise<MedicaidProgram[]> {
    return await this.makeGet<MedicaidProgram[]>(`get-medicaid-market-opportunity-programs/${stateCode}`, null, this.marketExpansionEndpoint, false, undefined, signal);
  }

  public async searchMedicaidCountyPlanCounts(filterCriteria: MedicaidMarketOpportunityFilterCriteria): Promise<MedicaidCountyPrograms[]> {
    return await this.makePost(`search-medicaid-market-opportunity-county-plan-counts`, filterCriteria, this.marketExpansionEndpoint);
  }

  public async searchMedicaidPayerDistinctPlanCounts(filterCriteria: MedicaidMarketShareFilterCriteria, signal?: AbortSignal): Promise<MedicaidPayerPlanCount[]> {
    return await this.makePost(`search-medicaid-market-opportunity-payers-market-share`, filterCriteria, this.marketExpansionEndpoint, false, "application/json", true, undefined, signal);
  }

  public async searchProviderLandscapeRecords(filterCriteria: ProviderLandscapeFilterCriteria): Promise<ProviderLandscapeCountyCaseCount[]> {
    return await this.makePost(`search-provider-landscape-records`, filterCriteria, this.marketExpansionEndpoint);
  }

  public async searchProviderFootprintRecords(filterCriteria: ProviderFootprintFilterCriteria): Promise<ProviderFootprintRecord[]> {
    return await this.makePost(`search-provider-footprint-records`, filterCriteria, this.marketExpansionEndpoint);
  }
}
